import React from 'react';
import { childQuestions, parentReplies } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function ParentPain() {
  return <section className="bg-paper py-12 lg:py-20" data-id="element-158" data-mp="vfqdzaolk3qz">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-159" data-mp="qm5hxo6kdjuf">
        <SectionHeading title="How Many Times Have You Reassured Your Child Today?" data-id="element-160" data-mp="lnu4l3h28r7g" />

        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-4 sm:gap-8 lg:mt-14" data-id="element-161" data-mp="llrdsh832u1o">
          <div data-id="element-162" data-mp="hk5vuhgozpkm">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ink-mute sm:text-[12px]" data-id="element-163" data-mp="hjw870j4dui3">What you hear</p>
            <ul className="mt-3 space-y-2.5 sm:space-y-3" data-id="element-164" data-mp="7njcxy7xf8l8">
              {childQuestions.map(q => <li key={q} className="rounded-2xl rounded-bl-md bg-dusty-wash px-3.5 py-2.5 text-[14px] leading-snug text-ink sm:px-5 sm:py-3 sm:text-[17px]" data-id="element-165" data-mp="2prm77j0psim">
                  “{q}”
                </li>)}
            </ul>
          </div>
          <div data-id="element-166" data-mp="1x0witrvot4og">
            <p className="text-right text-[11px] font-semibold uppercase tracking-[0.16em] text-ink-mute sm:text-[12px]" data-id="element-167" data-mp="1rv93opn0xloy">What you say</p>
            <ul className="mt-3 space-y-2.5 sm:space-y-3" data-id="element-168" data-mp="1wvdjsek0seen">
              {parentReplies.map(r => <li key={r} className="rounded-2xl rounded-br-md bg-sage-wash px-3.5 py-2.5 text-right text-[14px] font-medium leading-snug text-ink sm:px-5 sm:py-3 sm:text-[17px]" data-id="element-169" data-mp="1hy4pbbzf6uip">
                  “{r}”
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl text-center lg:mt-16" data-id="element-170" data-mp="2fmwp4s1io4ju">
          <p className="font-display text-[28px] leading-tight text-ink sm:text-[36px]" data-id="element-171" data-mp="20ve9ivckkc10">It helps for a moment.</p>
          <p className="mt-2 font-display text-[22px] italic leading-snug text-ink/60 sm:text-[28px]" data-id="element-172" data-mp="25t7hntxfng3x">
            Five minutes later… the question comes back.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-xl border-t border-cream-line pt-8 text-center" data-id="element-173" data-mp="2ycw6esr48fcp">
          <p className="text-[17px] leading-relaxed text-ink-soft" data-id="element-174" data-mp="386rzm2a93c4w">
            You’re trying to help your child feel safe. But eventually you may start wondering:
          </p>
          <p className="mt-3 font-display text-[26px] italic leading-snug text-terra-dark sm:text-[30px]" data-id="element-175" data-mp="2z5keklwqw7sr">
            “What am I supposed to say instead?”
          </p>
        </div>
      </div>
    </section>;
}